import { useDispatch, useSelector } from 'react-redux'
import useFetch from '../../../_services/fetch'
import { GenderEnum } from '../../../enums/GenderEnum'
import { Icon } from '../../Elements'
import Avatar from '../ImageAvatars/Avatar'
import { RaytebRequests } from '../../../_services'
import { PrescriptionViewModel } from '../../../models/ViewModels/PrescriptionViewModel'
import { useNavigate } from 'react-router'
import { addOrUpdatePrescription } from '../../../storeManager/Reducers/prescriptionSlice'
import LoadingFit from '../Loading/LoadingFit'
import PreviewPrescriptionModal from '../Modal/PreviewPrescriptionModal'
import { useState } from 'react'
import { ReducerType } from '../../../storeManager/ReducerType'

const SamadCard: React.FC<SamadCardInterface> = ({
  model,
  centerId,
  token,
}) => {
  const dispatch = useDispatch()
  const navigation = useNavigate()
  const [showPreview, setShowPreview] = useState<boolean>(false)
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )

  const { isLoading, reFetch } = useFetch<PrescriptionViewModel, Object>({
    request: RaytebRequests.Prescription_Get_POST({
      headers: { centerId: centerId },
      token: token,
    }),
    onSuccess(data) {
      dispatch(addOrUpdatePrescription(data))
      navigation('/prescription/newPrescription')
    },
  })
  const getPrescription = useFetch<
    PrescriptionViewModel,
    GetPrescriptionIHIOInputModel
  >({
    request: RaytebRequests.IHIO_GetPrescription_POST({
      headers: { centerId: centerId },
      token: token,
    }),
    onSuccess(data) {
      setShowPreview(true)
    },
  })
  return (
    <>
      <div className='p-3 grid grid-cols-8 bg-white shadow-inner rounded-sm gap-4 relative'>
        <LoadingFit isLoading={isLoading || getPrescription.isLoading} />
        <div className='col-span-2'>
          <Avatar url={model.image ?? null} className='!h-16 !w-16' />
        </div>
        <div className='col-span-6 pt-3 px-3 flex flex-col justify-center items-start gap-5'>
          <div className='w-full flex justify-between items-center'>
            <h2 className='text-sm font-bold '>{`${model.name} ${model.lastName}`}</h2>

            <div className='flex justify-center items-center gap-3'>
              {model.ticketId && (center.hasPrescription || center.hasRecord) ? (
                <Icon
                  icon='rayteb-edit'
                  className='text-xl text-warn'
                  onClick={() => {
                    reFetch({
                      code: model.personCode,
                      ticketId: model.ticketId,
                    })
                  }}
                />
              ) : (
                ''
              )}
              <Icon
                icon='rayteb-view'
                className='text-2xl text-secondaryDark'
                onClick={() => {
                  getPrescription.reFetch({
                    patientCode: model.personCode,
                    samadCode: model.samadCode,
                  })
                }}
              />
            </div>
          </div>
          <div className='flex w-full justify-between items-center'>
            <span className='text-xs text-primaryLight'>
              {model.personCode}
            </span>

            <p className='flex justify-center items-center gap-2 text-xs font-bold text-primaryLight'>
              <span>{GenderEnum[model.gender]}</span>
              <span>{model.age}</span>
            </p>
          </div>
        </div>
        <div className='col-span-8  px-3 flex  justify-between items-center gap-3'>
          <span className='text-xs text-primaryLight font-bold'>
            {`کد رهگیری : ${model.trackingCode}`}
          </span>
          <span className='text-xs text-primaryLight font-bold'>
            {`تاریخ درج : ${new Date(model.createDate).toShamsi()}`}
          </span>
          <span className='text-xs text-primaryLight'>{model.productName}</span>
        </div>
      </div>
      <PreviewPrescriptionModal
        isOpen={showPreview}
        prescription={getPrescription.result!}
        hideModal={() => setShowPreview(false)}
      />
    </>
  )
}

export default SamadCard
